{
  "previous": "Anterior",
  "next": "Próximo",
  "complete": "Concluir",
  "verifyAndCheckIn": "Verificar e fazer check-in",
  "loading": {
    "retrievingLocation": "Obtendo localização...",
    "retrievingWarehouse": "Obtendo dados do armazém..."
  },
  "validation": {
    "fieldRequired": "Este campo é obrigatório",
    "fieldRequiredWithLabel": "{label} é obrigatório",
    "phoneInvalid": "Este não é um número de telefone válido",
    "phoneInvalidWithExample": "Este não é um número de telefone válido (exemplo: {example})"
  }
}
